import { usePanelHistoryTop } from 'weblite-router'
import { OverlayWappPanel } from '$logic/wapp-panels'

export function useCurrentOverlayWappMeta() {
  usePanelHistoryTop('wappOverlay')

  // TODO: Optimize if necessary
  return OverlayWappPanel.getTopWappMeta()
}
